var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stake-area" },
    [
      _c("WindowModal", {
        attrs: { title: _vm.modalTitle, type: "Global" },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                _vm.currentPool !== null
                  ? _c("StakeAsset", {
                      ref: "stakeAsset",
                      attrs: {
                        pool: _vm.currentPool,
                        action: _vm.actionPicked,
                        transaction: _vm.transaction,
                      },
                      on: {
                        stake: _vm.stakePool,
                        unstake: _vm.unstakePool,
                        extend: _vm.extendLocked,
                        initConfirmState: function ($event) {
                          return _vm.changeModalTitle("init")
                        },
                        initLoading: function ($event) {
                          return _vm.changeModalTitle("loading")
                        },
                        initSuccess: function ($event) {
                          return _vm.changeModalTitle("success")
                        },
                        initError: function ($event) {
                          return _vm.changeModalTitle("error")
                        },
                        closeGlobalModal: _vm.closeModal,
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.currentStake !== null
        ? _c("RoiCalculator", {
            attrs: {
              token: _vm.currentStake.token,
              deposited: _vm.currentStakeDepend.deposited,
              apr: _vm.currentStakeDepend.apr,
              type: _vm.currentStakeDepend.type,
              balance: _vm.currentStakeDepend.balance,
              "performance-fee": _vm.currentStakeDepend.performanceFee,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "stake-box" }, [
        _c("div", { staticClass: "text-area" }, [
          _c("h1", [
            _vm._v("\n        " + _vm._s(_vm.$t("stake.stake")) + "\n      "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("stake.subheader1")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("stake.subheader2")) + "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "image-area" }, [
          _c("div", { staticClass: "picture" }, [
            _c(
              "picture",
              [
                _c("source", {
                  attrs: {
                    srcset: "/img/new/stake_hand.webp",
                    type: "image/webp",
                  },
                }),
                _vm._v(" "),
                _c("nuxt-img", {
                  attrs: {
                    fit: "inside",
                    width: "919",
                    sizes: "sm:300px md:400px lg:500px xl:600px xxl:700px",
                    src: "/img/new/stake_hand.png",
                    alt: "Farm $FLOATIE and harvest coin rewards on Defi Pool Finance",
                    title: "Farm $FLOATIE",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cyan-cloud" }, [_c("CloudCyanStakeLeft")], 1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cyan-cloud2" },
          [_c("CloudCyanStakeRight")],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filter-row" }, [
        _c("div", { staticClass: "start-area" }, [
          _c(
            "div",
            { staticClass: "switch-area" },
            [
              _c("Switcher", {
                attrs: { id: "stakedOnly", label: _vm.$t("stake.staked_only") },
                on: { select: _vm.changeStakedOnly },
                model: {
                  value: _vm.filter.stakedOnly,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "stakedOnly", $$v)
                  },
                  expression: "filter.stakedOnly",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "status-area" }, [
            _c(
              "button",
              {
                class: {
                  "btn-status": true,
                  active: _vm.filter.status === "live",
                },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setStatus("live")
                  },
                },
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("stake.live")) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                class: {
                  "btn-status": true,
                  active: _vm.filter.status === "finished",
                },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setStatus("finished")
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("stake.finished")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "end-area" }, [
          _c(
            "div",
            { staticClass: "sort-area" },
            [
              _c("label", { attrs: { for: "sortList" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("common.sort_by")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("Select", {
                attrs: { options: _vm.filterOptions },
                model: {
                  value: _vm.filter.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "sort", $$v)
                  },
                  expression: "filter.sort",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "search-area" }, [
            _c(
              "div",
              { staticClass: "search-input" },
              [
                _c("Search"),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.search,
                      expression: "filter.search",
                    },
                  ],
                  attrs: {
                    type: "text",
                    сlass: "input",
                    placeholder: _vm.$t("common.search") + "...",
                  },
                  domProps: { value: _vm.filter.search },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filter, "search", $event.target.value)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.lockedPool !== null && !_vm.lockedPoolLoading
        ? _c(
            "div",
            { staticClass: "pools-area" },
            [
              _vm.lockedPool !== null
                ? _c("div", { staticClass: "pool-item" }, [
                    _c(
                      "div",
                      {
                        ref: "poolHeader999",
                        class: {
                          "pool-header": true,
                          active: _vm.lockedPool.opened,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleAccordion(999)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "logo" },
                          [
                            _c("nuxt-img", {
                              attrs: {
                                placeholder: "",
                                src: "/img/new/floatie_item.svg",
                                alt: "$FLOATIE stake pool for earning auto flexible rewards",
                                title: "$FLOATIE stake pool",
                                loading: "lazy",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "refresh-icon" },
                              [_c("Refresh")],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-area" }, [
                          _c("div", { staticClass: "h4" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("stake.locked_stake")) +
                                " " +
                                _vm._s(_vm.$config.floatieName) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "desc" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("stake.pool_desc")) +
                                "\n          "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "regular-item stacked-area no-mobile-border",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "icon-area" },
                              [_c("Cube")],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "value-area" }, [
                              _c("p", { staticClass: "desc" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("stake.earned")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "value" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$formatCryptoAmount(
                                        _vm.lockedPool.earned,
                                        6
                                      ) +
                                        " " +
                                        _vm.$config.floatieSymbol
                                    ) +
                                    " / " +
                                    _vm._s(
                                      _vm.convertToUsd(_vm.lockedPool.earned)
                                    ) +
                                    " USD\n            "
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "regular-item apy-area" }, [
                          _c(
                            "div",
                            { staticClass: "icon-area" },
                            [_c("Cubes")],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "value-area" }, [
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("stake.locked")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.lockedPool.info.floatieAtLastUserAction !== -1
                              ? _c("p", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$formatCryptoAmount(
                                          _vm.lockedPool.info
                                            .floatieAtLastUserAction
                                        ) +
                                          " " +
                                          _vm.$config.floatieSymbol
                                      ) +
                                      "\n            "
                                  ),
                                ])
                              : _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _c("Skeleton", {
                                      attrs: { width: "60px", height: "16px" },
                                    }),
                                  ],
                                  1
                                ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "regular-item apr-area" }, [
                          _c(
                            "div",
                            { staticClass: "icon-area" },
                            [_c("Cubes")],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "value-area" }, [
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("stake.locked") +
                                      " " +
                                      _vm.$t("stake.apy")
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.lockedPool.apy !== -1
                              ? _c("p", { staticClass: "value" }, [
                                  _c("span", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.lockedPool.apy > 1000
                                            ? _vm.$getBigNumber(
                                                _vm.lockedPool.apy
                                              )
                                            : _vm.$priceFormat(
                                                _vm.lockedPool.apy,
                                                2
                                              )
                                        ) +
                                        "%\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "roi-icon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openRoiCalculator(
                                            _vm.lockedPool
                                          )
                                        },
                                      },
                                    },
                                    [_c("Calculator")],
                                    1
                                  ),
                                ])
                              : _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _c("Skeleton", {
                                      attrs: { width: "60px", height: "16px" },
                                    }),
                                  ],
                                  1
                                ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "regular-item total-area" }, [
                          _c(
                            "div",
                            { staticClass: "icon-area" },
                            [_c("Cubes")],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "value-area" }, [
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("stake.total_locked")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    (_vm.lockedPool.totalLocked > 1000
                                      ? _vm.$priceFormat(
                                          _vm.lockedPool.totalLocked,
                                          0
                                        )
                                      : _vm.$priceFormat(
                                          _vm.lockedPool.totalLocked,
                                          2
                                        )) +
                                      " " +
                                      _vm.$config.floatieSymbol
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "trigger-area" }, [
                          _c(
                            "p",
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    !_vm.lockedPool.opened
                                      ? _vm.$t("common.show")
                                      : _vm.$t("common.hide")
                                  ) +
                                  "\n            "
                              ),
                              _c("ChevronDown"),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "poolDetails999",
                        class: {
                          "pool-details": true,
                          active: _vm.lockedPool.opened,
                        },
                      },
                      [
                        _c("div", { staticClass: "stake-container" }, [
                          _c("div", { staticClass: "desc-area" }, [
                            _c("div", { staticClass: "desc-row avg-lock" }, [
                              _c("p", { staticClass: "desc" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("stake.avg_lock_duration")) +
                                    ":\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s("1-52 " + _vm.$t("common.weeks")) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "desc-row performance" }, [
                              _c("p", { staticClass: "desc" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("stake.performance_fee")) +
                                    ":\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                0-" +
                                    _vm._s(
                                      _vm.$priceFormat(
                                        _vm.lockedPool.performanceFee,
                                        0
                                      ) + "%"
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "desc-row status" }, [
                              _c(
                                "div",
                                { staticClass: "status-bar auto" },
                                [
                                  _c("Refresh"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("stake.auto")) +
                                        "\n                "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "numbers-area" }, [
                            _c(
                              "div",
                              { staticClass: "input-area recent-profit" },
                              [
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "h6" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("stake.recent") +
                                            " " +
                                            _vm.$config.floatieName +
                                            " " +
                                            _vm.$t("stake.profit")
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h3" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$formatCryptoAmount(
                                            _vm.lockedPool.earned,
                                            6
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("span", { staticClass: "currency" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.$config.floatieSymbol) +
                                          "\n                  "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h5" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.convertToUsd(
                                            _vm.lockedPool.earned
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("span", { staticClass: "currency" }, [
                                      _vm._v(
                                        "\n                    USD\n                  "
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.lockedPool.info.lockedAmount > 0
                                  ? _c("div", { staticClass: "info" }, [
                                      _c("div", { staticClass: "h6" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("stake.unlocks")) +
                                            "\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "h3" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.unlocksRealDate()) +
                                            "\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "h5" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("common.on") +
                                                " " +
                                                _vm.$beautifyDate(
                                                  parseInt(
                                                    _vm.lockedPool.info
                                                      .lockEndTime,
                                                    10
                                                  ) * 1000
                                                )
                                            ) +
                                            "\n                "
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.lockedPeriodEnded() ||
                            _vm.lockedPool.info.locked === false
                              ? _c("div", { staticClass: "buttons-area" }, [
                                  _c(
                                    "button",
                                    {
                                      class: {
                                        "btn cyan": true,
                                        loading: _vm.stakeLoading,
                                        disabled: _vm.stakeLoading,
                                      },
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.prepareStaking(
                                            _vm.lockedPool
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.lockedPool.info.locked ===
                                              true &&
                                              _vm.lockedPool.info.lockedAmount >
                                                0
                                              ? _vm.$t("stake.add_floatie")
                                              : _vm.$t("stake.stake")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.lockedPool.info.lockedAmount > 0
                                    ? _c(
                                        "button",
                                        {
                                          class: {
                                            "btn cyan": true,
                                            loading: _vm.stakeLoading,
                                            disabled: _vm.stakeLoading,
                                          },
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.prepareExtend(
                                                _vm.lockedPool
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("stake.extend")) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm.lockedPool.info.locked === true
                              ? _c("div", { staticClass: "info-area" }, [
                                  _c(
                                    "div",
                                    { staticClass: "icon-area" },
                                    [
                                      _c("WarnCircleIcon"),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "desc" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("stake.lock_can_be_burned")
                                            ) +
                                            "\n                "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "buttons-area" }, [
                                    _c(
                                      "button",
                                      {
                                        class: {
                                          "btn cyan": true,
                                          loading: _vm.stakeLoading,
                                          disabled: _vm.stakeLoading,
                                        },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.prepareExtend(
                                              _vm.lockedPool
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("stake.renew")) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        class: {
                                          "btn cyan btn-outline": true,
                                          loading: _vm.stakeLoading,
                                          disabled: _vm.stakeLoading,
                                        },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.unstakeLocked(
                                              _vm.lockedPool.info.lockedAmount
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("stake.unstake")) +
                                              "\n                  "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "help-area" }, [
                          _c("div", { staticClass: "help-list" }, [
                            _c("div", { staticClass: "item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "bottom-link",
                                  attrs: {
                                    href: _vm.generateTokenInfoLink({
                                      address: _vm.$config.periodToken,
                                    }),
                                    rel: "nofollow noopener noreferrer",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("ChevronRight"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("stake.token_info")) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "item" },
                              [
                                _c(
                                  "nuxt-link",
                                  {
                                    staticClass: "bottom-link",
                                    attrs: { to: _vm.localePath("/docs") },
                                  },
                                  [
                                    _c("ChevronRight"),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("stake.view_tutorial")) +
                                        "\n              "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "bottom-link",
                                  attrs: {
                                    href: _vm.generateScanLink({
                                      address: _vm.$config.periodVault,
                                    }),
                                    rel: "nofollow noopener noreferrer",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("ChevronRight"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("stake.view_contract")) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "item" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "bottom-link",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$addToMetamask(
                                        _vm.lockedPool.token
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("ChevronRight"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("common.add_to_metamask")) +
                                      "\n                "
                                  ),
                                  _c("MetamaskIcon"),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _c("div", { staticClass: "pool-item" }, [
                    _c("div", { staticClass: "pool-header" }, [
                      _c(
                        "div",
                        { staticClass: "logo" },
                        [
                          _c("Skeleton", {
                            attrs: {
                              width: "42px",
                              height: "42px",
                              circle: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "header-area" },
                        [
                          _c("Skeleton", {
                            staticStyle: { "margin-bottom": ".25rem" },
                            attrs: { width: "150px", height: "14px" },
                          }),
                          _vm._v(" "),
                          _c("Skeleton", {
                            attrs: { width: "175px", height: "18px" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "regular-item no-mobile-border" },
                        [
                          _c(
                            "div",
                            { staticClass: "icon-area" },
                            [
                              _c("Skeleton", {
                                attrs: { width: "21px", height: "21px" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "value-area" },
                            [
                              _c("Skeleton", {
                                staticStyle: { "margin-bottom": ".25rem" },
                                attrs: { width: "45px", height: "14px" },
                              }),
                              _vm._v(" "),
                              _c("Skeleton", {
                                attrs: { width: "100px", height: "18px" },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "regular-item" }, [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [
                            _c("Skeleton", {
                              attrs: { width: "21px", height: "21px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value-area" },
                          [
                            _c("Skeleton", {
                              staticStyle: { "margin-bottom": ".25rem" },
                              attrs: { width: "45px", height: "14px" },
                            }),
                            _vm._v(" "),
                            _c("Skeleton", {
                              attrs: { width: "100px", height: "18px" },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "regular-item" }, [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [
                            _c("Skeleton", {
                              attrs: { width: "21px", height: "21px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value-area" },
                          [
                            _c("Skeleton", {
                              staticStyle: { "margin-bottom": ".25rem" },
                              attrs: { width: "45px", height: "14px" },
                            }),
                            _vm._v(" "),
                            _c("Skeleton", {
                              attrs: { width: "100px", height: "18px" },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "regular-item" }, [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [
                            _c("Skeleton", {
                              attrs: { width: "21px", height: "21px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value-area" },
                          [
                            _c("Skeleton", {
                              staticStyle: { "margin-bottom": ".25rem" },
                              attrs: { width: "45px", height: "14px" },
                            }),
                            _vm._v(" "),
                            _c("Skeleton", {
                              attrs: { width: "100px", height: "18px" },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "trigger-area" },
                        [
                          _c("Skeleton", {
                            attrs: { width: "50px", height: "18x" },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
              _vm._v(" "),
              _vm.flexiblePool !== null
                ? _c("div", { staticClass: "pool-item" }, [
                    _c(
                      "div",
                      {
                        ref: "poolHeader1000",
                        class: {
                          "pool-header": true,
                          active: _vm.flexiblePool.opened,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleAccordion(1000)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "logo" },
                          [
                            _c("nuxt-img", {
                              attrs: {
                                placeholder: "",
                                src: "/img/new/floatie_item.svg",
                                alt: "$FLOATIE stake pool for earning auto flexible rewards",
                                title: "$FLOATIE stake pool",
                                loading: "lazy",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "refresh-icon" },
                              [_c("Refresh")],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-area" }, [
                          _c("div", { staticClass: "h4" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("stake.flexible_stake")) +
                                " " +
                                _vm._s(_vm.$config.floatieName) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "desc" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("stake.pool_desc")) +
                                "\n          "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "regular-item stacked-area no-mobile-border",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "icon-area" },
                              [_c("Cube")],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "value-area" }, [
                              _c("p", { staticClass: "desc" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("stake.earned")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "value" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$formatCryptoAmount(
                                        _vm.flexiblePool.earned,
                                        6
                                      ) +
                                        " " +
                                        _vm.$config.floatieSymbol
                                    ) +
                                    " / " +
                                    _vm._s(
                                      _vm.convertToUsd(_vm.flexiblePool.earned)
                                    ) +
                                    " USD\n            "
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "regular-item apy-area" }, [
                          _c(
                            "div",
                            { staticClass: "icon-area" },
                            [_c("Cubes")],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "value-area" }, [
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("stake.locked")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.flexiblePool.info.lockedAmount !== -1
                              ? _c("p", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$formatCryptoAmount(
                                          _vm.flexiblePool.info.lockedAmount
                                        ) +
                                          " " +
                                          _vm.$config.floatieSymbol
                                      ) +
                                      "\n            "
                                  ),
                                ])
                              : _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _c("Skeleton", {
                                      attrs: { width: "60px", height: "16px" },
                                    }),
                                  ],
                                  1
                                ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "regular-item apr-area" }, [
                          _c(
                            "div",
                            { staticClass: "icon-area" },
                            [_c("Cubes")],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "value-area" }, [
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("stake.locked") +
                                      " " +
                                      _vm.$t("stake.apy")
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.flexiblePool.apy !== -1
                              ? _c("p", { staticClass: "value" }, [
                                  _c("span", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.flexiblePool.apy > 1000
                                            ? _vm.$getBigNumber(
                                                _vm.flexiblePool.apy
                                              )
                                            : _vm.$priceFormat(
                                                _vm.flexiblePool.apy,
                                                2
                                              )
                                        ) +
                                        "%\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.openRoiCalculator(
                                            _vm.flexiblePool
                                          )
                                        },
                                      },
                                    },
                                    [_c("Calculator")],
                                    1
                                  ),
                                ])
                              : _c(
                                  "div",
                                  { staticClass: "value" },
                                  [
                                    _c("Skeleton", {
                                      attrs: { width: "60px", height: "16px" },
                                    }),
                                  ],
                                  1
                                ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "regular-item total-area" }, [
                          _c(
                            "div",
                            { staticClass: "icon-area" },
                            [_c("Cubes")],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "value-area" }, [
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("stake.total_locked")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    (_vm.flexiblePool.totalLocked > 1000
                                      ? _vm.$priceFormat(
                                          _vm.flexiblePool.totalLocked,
                                          0
                                        )
                                      : _vm.$priceFormat(
                                          _vm.flexiblePool.totalLocked,
                                          2
                                        )) +
                                      " " +
                                      _vm.$config.floatieSymbol
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "trigger-area" }, [
                          _c(
                            "p",
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    !_vm.flexiblePool.opened
                                      ? _vm.$t("common.show")
                                      : _vm.$t("common.hide")
                                  ) +
                                  "\n            "
                              ),
                              _c("ChevronDown"),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "poolDetails1000",
                        class: {
                          "pool-details": true,
                          active: _vm.flexiblePool.opened,
                        },
                      },
                      [
                        _c("div", { staticClass: "stake-container" }, [
                          _c("div", { staticClass: "desc-area" }, [
                            _c("div", { staticClass: "desc-row performance" }, [
                              _c("p", { staticClass: "desc" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("stake.performance_fee")) +
                                    ":\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                0-" +
                                    _vm._s(
                                      _vm.$priceFormat(
                                        _vm.flexiblePool.performanceFee,
                                        0
                                      ) + "%"
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "desc-row performance" }, [
                              _c("p", { staticClass: "desc" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("stake.unstaking_fee")) +
                                    ":\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$priceFormat(
                                        _vm.flexiblePool.withdrawFee,
                                        1
                                      ) + "%"
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "desc-row performance" }, [
                              _c("p", { staticClass: "desc" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("stake.unstaking_period")) +
                                    ":\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$priceFormat(
                                        _vm.flexiblePool.withdrawFeePeriod,
                                        0
                                      ) + _vm.$t("common.d")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "desc-row performance" }, [
                              _c("p", { staticClass: "desc" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("stake.current_withdraw_fee")
                                    ) +
                                    ":\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "value highlighted" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.flexiblePool.info.unstakeFee + "%"
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "desc-row status" }, [
                              _c(
                                "div",
                                { staticClass: "status-bar auto" },
                                [
                                  _c("Refresh"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("stake.auto")) +
                                        "\n                "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "numbers-area" }, [
                            _c(
                              "div",
                              { staticClass: "input-area recent-profit" },
                              [
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "h6" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("stake.recent") +
                                            " " +
                                            _vm.$config.floatieName +
                                            " " +
                                            _vm.$t("stake.profit")
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h3" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$formatCryptoAmount(
                                            _vm.flexiblePool.earned,
                                            6
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("span", { staticClass: "currency" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.$config.floatieSymbol) +
                                          "\n                  "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h5" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.convertToUsd(
                                            _vm.flexiblePool.earned
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("span", { staticClass: "currency" }, [
                                      _vm._v(
                                        "\n                    USD\n                  "
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "h6" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("stake.floatie_staked")) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h3" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$formatCryptoAmount(
                                            _vm.flexiblePool.info.lockedAmount
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("span", { staticClass: "currency" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.$config.floatieSymbol) +
                                          "\n                  "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h5" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.convertToUsd(
                                            _vm.flexiblePool.info.lockedAmount
                                          ) + " USD"
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "buttons-area" }, [
                              _vm.flexiblePool.info.lockedAmount !== 0
                                ? _c(
                                    "button",
                                    {
                                      class: {
                                        "btn cyan": true,
                                        loading: _vm.stakeLoading,
                                        disabled: _vm.stakeLoading,
                                      },
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.prepareUnstaking(
                                            _vm.flexiblePool
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("stake.unstake")) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  class: {
                                    "btn cyan": true,
                                    loading: _vm.stakeLoading,
                                    disabled: _vm.stakeLoading,
                                  },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.prepareStaking(
                                        _vm.flexiblePool
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("stake.stake")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "help-area" }, [
                          _c("div", { staticClass: "help-list" }, [
                            _c("div", { staticClass: "item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "bottom-link",
                                  attrs: {
                                    href: _vm.generateTokenInfoLink({
                                      address: _vm.$config.periodToken,
                                    }),
                                    rel: "nofollow noopener noreferrer",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("ChevronRight"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("stake.token_info")) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "item" },
                              [
                                _c(
                                  "nuxt-link",
                                  {
                                    staticClass: "bottom-link",
                                    attrs: { to: _vm.localePath("/docs") },
                                  },
                                  [
                                    _c("ChevronRight"),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("stake.view_tutorial")) +
                                        "\n              "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "bottom-link",
                                  attrs: {
                                    href: _vm.generateScanLink({
                                      address: _vm.$config.periodFlexibleVault,
                                    }),
                                    rel: "nofollow noopener noreferrer",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("ChevronRight"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("stake.view_contract")) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "item" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "bottom-link",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$addToMetamask(
                                        _vm.flexiblePool.token
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("ChevronRight"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("common.add_to_metamask")) +
                                      "\n                "
                                  ),
                                  _c("MetamaskIcon"),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _c("div", { staticClass: "pool-item" }, [
                    _c("div", { staticClass: "pool-header" }, [
                      _c(
                        "div",
                        { staticClass: "logo" },
                        [
                          _c("Skeleton", {
                            attrs: {
                              width: "42px",
                              height: "42px",
                              circle: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "header-area" },
                        [
                          _c("Skeleton", {
                            staticStyle: { "margin-bottom": ".25rem" },
                            attrs: { width: "150px", height: "14px" },
                          }),
                          _vm._v(" "),
                          _c("Skeleton", {
                            attrs: { width: "175px", height: "18px" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "regular-item no-mobile-border" },
                        [
                          _c(
                            "div",
                            { staticClass: "icon-area" },
                            [
                              _c("Skeleton", {
                                attrs: { width: "21px", height: "21px" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "value-area" },
                            [
                              _c("Skeleton", {
                                staticStyle: { "margin-bottom": ".25rem" },
                                attrs: { width: "45px", height: "14px" },
                              }),
                              _vm._v(" "),
                              _c("Skeleton", {
                                attrs: { width: "100px", height: "18px" },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "regular-item" }, [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [
                            _c("Skeleton", {
                              attrs: { width: "21px", height: "21px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value-area" },
                          [
                            _c("Skeleton", {
                              staticStyle: { "margin-bottom": ".25rem" },
                              attrs: { width: "45px", height: "14px" },
                            }),
                            _vm._v(" "),
                            _c("Skeleton", {
                              attrs: { width: "100px", height: "18px" },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "regular-item" }, [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [
                            _c("Skeleton", {
                              attrs: { width: "21px", height: "21px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value-area" },
                          [
                            _c("Skeleton", {
                              staticStyle: { "margin-bottom": ".25rem" },
                              attrs: { width: "45px", height: "14px" },
                            }),
                            _vm._v(" "),
                            _c("Skeleton", {
                              attrs: { width: "100px", height: "18px" },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "regular-item" }, [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [
                            _c("Skeleton", {
                              attrs: { width: "21px", height: "21px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value-area" },
                          [
                            _c("Skeleton", {
                              staticStyle: { "margin-bottom": ".25rem" },
                              attrs: { width: "45px", height: "14px" },
                            }),
                            _vm._v(" "),
                            _c("Skeleton", {
                              attrs: { width: "100px", height: "18px" },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "trigger-area" },
                        [
                          _c("Skeleton", {
                            attrs: { width: "50px", height: "18x" },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
              _vm._v(" "),
              _vm._l(_vm.pools, function (pool, index) {
                return _c("div", { key: index, staticClass: "pool-item" }, [
                  _c(
                    "div",
                    {
                      ref: "poolHeader" + index,
                      refInFor: true,
                      class: { "pool-header": true, active: pool.opened },
                      on: {
                        click: function ($event) {
                          return _vm.toggleAccordion(index)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "logo" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.$getImage(pool.token.logoURI),
                            alt: "$FLOATIE stake pool for earning auto flexible rewards",
                            title: "$FLOATIE stake pool",
                          },
                        }),
                        _vm._v(" "),
                        pool.mode === "auto"
                          ? _c(
                              "div",
                              { staticClass: "refresh-icon" },
                              [_c("Refresh")],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "header-area" }, [
                        _c("div", { staticClass: "h4" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("stake.stake")) +
                              " " +
                              _vm._s(pool.token.name) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "desc" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("stake.pool_desc")) +
                              "\n          "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "regular-item stacked-area no-mobile-border",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "icon-area" },
                            [_c("Cube")],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "value-area" }, [
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("stake.staked")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$formatCryptoAmount(pool.staked)) +
                                  " / " +
                                  _vm._s(_vm.convertToUsd(pool.staked)) +
                                  " USD\n            "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "regular-item apy-area" }, [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [_c("Cubes")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "value-area" }, [
                          _c("p", { staticClass: "desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("stake.total_staked")) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$formatCryptoAmount(pool.total) +
                                    " " +
                                    pool.token.symbol
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "regular-item apr-area" }, [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [_c("Cubes")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "value-area" }, [
                          _c("p", { staticClass: "desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("stake.apr")) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value" }, [
                            _c("span", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    pool.apr > 1000
                                      ? _vm.$getBigNumber(pool.apr)
                                      : _vm.$priceFormat(pool.apr, 2)
                                  ) +
                                  "%\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openRoiCalculator(pool)
                                  },
                                },
                              },
                              [_c("Calculator")],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "regular-item total-area" }, [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [_c("Cubes")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "value-area" }, [
                          _c("p", { staticClass: "desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("stake.ends_in")) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$priceFormat(pool.ends, 0) +
                                    " " +
                                    _vm.$t("stake.blocks")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trigger-area" }, [
                        _c(
                          "p",
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  !pool.opened
                                    ? _vm.$t("common.show")
                                    : _vm.$t("common.hide")
                                ) +
                                "\n            "
                            ),
                            _c("ChevronDown"),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "poolDetails" + index,
                      refInFor: true,
                      class: { "pool-details": true, active: pool.opened },
                    },
                    [
                      _c("div", { staticClass: "stake-container" }, [
                        _c("div", { staticClass: "desc-area" }, [
                          _c("div", { staticClass: "desc-row total" }, [
                            _c("p", { staticClass: "desc" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("stake.total_locked")) +
                                  ":\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$priceFormat(pool.apr, 2) + "%") +
                                  "\n              "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          pool.ends !== 0
                            ? _c("div", { staticClass: "desc-row avg-lock" }, [
                                _c("p", { staticClass: "desc" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("stake.ends_in")) +
                                      ":\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$priceFormat(pool.ends, 0) +
                                          " " +
                                          _vm.$t("stake.blocks")
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ])
                            : _c("div", { staticClass: "desc-row avg-lock" }, [
                                _c("p", { staticClass: "desc" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("stake.ends_in")) +
                                      ":\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "value" }, [
                                  _vm._v("\n                ∞\n              "),
                                ]),
                              ]),
                          _vm._v(" "),
                          pool.index === 0
                            ? _c(
                                "div",
                                { staticClass: "desc-row performance" },
                                [
                                  _c("p", { staticClass: "desc" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("stake.performance_fee")
                                        ) +
                                        ":\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "value" }, [
                                    _vm._v(
                                      "\n                ~" +
                                        _vm._s(
                                          _vm.$priceFormat(
                                            pool.performance,
                                            2
                                          ) + "%"
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "desc-row status" }, [
                            _c(
                              "div",
                              { staticClass: "status-bar manual" },
                              [
                                _c("Update"),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("stake.manual")) +
                                      "\n                "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "numbers-area" }, [
                          _c(
                            "div",
                            { staticClass: "input-area recent-profit" },
                            [
                              _c("div", { staticClass: "info" }, [
                                _c("div", { staticClass: "h6" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("stake.recent") +
                                          " " +
                                          pool.token.name +
                                          " " +
                                          _vm.$t("stake.profit")
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "h3" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$formatCryptoAmount(pool.pending)
                                      ) +
                                      "\n                  "
                                  ),
                                  _c("span", { staticClass: "currency" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(pool.token.symbol) +
                                        "\n                  "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "h5" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.convertToUsd(pool.pending)) +
                                      "\n                  "
                                  ),
                                  _c("span", { staticClass: "currency" }, [
                                    _vm._v(
                                      "\n                    USD\n                  "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "action" }, [
                                _c(
                                  "button",
                                  {
                                    class: {
                                      "btn cyan": true,
                                      disabled:
                                        pool.pending === 0 || _vm.stakeLoading,
                                    },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.prepareUnstaking(pool)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("stake.unstake")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-area pool-actions" },
                            [
                              _c("div", { staticClass: "info" }, [
                                _c("div", { staticClass: "h6" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("stake.start_staking")) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: pool.stakeAmount,
                                      expression: "pool.stakeAmount",
                                    },
                                  ],
                                  attrs: {
                                    type: "number",
                                    step: "0.00001",
                                    lang: "en",
                                    min: "0",
                                    placeholder: "0...",
                                  },
                                  domProps: { value: pool.stakeAmount },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        pool,
                                        "stakeAmount",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "h5" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.convertToUsd(pool.stakeAmount)
                                      ) +
                                      "\n                  "
                                  ),
                                  _c("span", { staticClass: "currency" }, [
                                    _vm._v(
                                      "\n                    USD\n                  "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "action" }, [
                                _c(
                                  "button",
                                  {
                                    class: {
                                      "btn cyan": true,
                                      loading:
                                        pool.loadingStake || _vm.stakeLoading,
                                      disabled:
                                        pool.stakeAmount === null ||
                                        pool.stakeAmount === 0 ||
                                        _vm.stakeLoading,
                                    },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.prepareStaking(pool)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("stake.stake")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "help-area" }, [
                        _c("div", { staticClass: "help-list" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "bottom-link",
                                attrs: {
                                  href: _vm.generateTokenInfoLink(pool.token),
                                  rel: "nofollow noopener noreferrer",
                                  target: "_blank",
                                },
                              },
                              [
                                _c("ChevronRight"),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("stake.token_info")) +
                                    "\n              "
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "item" },
                            [
                              _c(
                                "nuxt-link",
                                {
                                  staticClass: "bottom-link",
                                  attrs: { to: _vm.localePath("/docs") },
                                },
                                [
                                  _c("ChevronRight"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("stake.view_tutorial")) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "bottom-link",
                                attrs: {
                                  href: _vm.generateScanLink(pool.token),
                                  rel: "nofollow noopener noreferrer",
                                  target: "_blank",
                                },
                              },
                              [
                                _c("ChevronRight"),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("stake.view_contract")) +
                                    "\n              "
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "p",
                              {
                                staticClass: "bottom-link",
                                on: {
                                  click: function ($event) {
                                    return _vm.$addToMetamask(pool.token)
                                  },
                                },
                              },
                              [
                                _c("ChevronRight"),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.add_to_metamask")) +
                                    "\n                "
                                ),
                                _c("MetamaskIcon"),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ])
              }),
            ],
            2
          )
        : _c("div", { staticClass: "pools-area" }, [
            _c(
              "div",
              { staticClass: "loading-area" },
              _vm._l(2, function (index) {
                return _c("div", { key: index, staticClass: "pool-item" }, [
                  _c("div", { staticClass: "pool-header" }, [
                    _c(
                      "div",
                      { staticClass: "logo" },
                      [
                        _c("Skeleton", {
                          attrs: { width: "42px", height: "42px", circle: "" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "header-area" },
                      [
                        _c("Skeleton", {
                          staticStyle: { "margin-bottom": ".25rem" },
                          attrs: { width: "150px", height: "14px" },
                        }),
                        _vm._v(" "),
                        _c("Skeleton", {
                          attrs: { width: "175px", height: "18px" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "regular-item no-mobile-border" },
                      [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [
                            _c("Skeleton", {
                              attrs: { width: "21px", height: "21px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value-area" },
                          [
                            _c("Skeleton", {
                              staticStyle: { "margin-bottom": ".25rem" },
                              attrs: { width: "45px", height: "14px" },
                            }),
                            _vm._v(" "),
                            _c("Skeleton", {
                              attrs: { width: "100px", height: "18px" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "regular-item" }, [
                      _c(
                        "div",
                        { staticClass: "icon-area" },
                        [
                          _c("Skeleton", {
                            attrs: { width: "21px", height: "21px" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "value-area" },
                        [
                          _c("Skeleton", {
                            staticStyle: { "margin-bottom": ".25rem" },
                            attrs: { width: "45px", height: "14px" },
                          }),
                          _vm._v(" "),
                          _c("Skeleton", {
                            attrs: { width: "100px", height: "18px" },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "regular-item" }, [
                      _c(
                        "div",
                        { staticClass: "icon-area" },
                        [
                          _c("Skeleton", {
                            attrs: { width: "21px", height: "21px" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "value-area" },
                        [
                          _c("Skeleton", {
                            staticStyle: { "margin-bottom": ".25rem" },
                            attrs: { width: "45px", height: "14px" },
                          }),
                          _vm._v(" "),
                          _c("Skeleton", {
                            attrs: { width: "100px", height: "18px" },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "regular-item" }, [
                      _c(
                        "div",
                        { staticClass: "icon-area" },
                        [
                          _c("Skeleton", {
                            attrs: { width: "21px", height: "21px" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "value-area" },
                        [
                          _c("Skeleton", {
                            staticStyle: { "margin-bottom": ".25rem" },
                            attrs: { width: "45px", height: "14px" },
                          }),
                          _vm._v(" "),
                          _c("Skeleton", {
                            attrs: { width: "100px", height: "18px" },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "trigger-area" },
                      [
                        _c("Skeleton", {
                          attrs: { width: "50px", height: "18x" },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }